import { useAuth } from '../context/AuthContext';

// Definimos el email y UID aquí para asegurar que funcione sin dependencias externas
const SUPER_USER_EMAIL = "Nelson.jtapia@gmail.com";
const SUPER_USER_UID = "5dFvhA7vcoS9Nee65RVS7JeODOx1";

/**
 * Hook personalizado para centralizar la lógica de permisos del usuario.
 * Versión corregida, robusta y compatible con el código original.
 */
export const usePermissions = () => {
  const { user } = useAuth();

  // 1. Definir quién es SuperUsuario (Combinamos UID y Email para seguridad máxima)
  const isSuperUser = user && (
      user.uid === SUPER_USER_UID || 
      user.email === SUPER_USER_EMAIL
  );

  // 2. Definir quién es Admin (Admin explícito O SuperUsuario)
  const isAdmin = (user?.role === 'admin') || isSuperUser;

  /**
   * Comprueba si el usuario tiene permiso para realizar una acción en un módulo.
   * @param {string} moduleId - El ID del módulo (ej. 'clients').
   * @param {string} action - La acción ('view', 'create', 'edit', 'delete').
   */
  const canDo = (moduleId, action) => {
    // Si no hay usuario logueado o datos cargados, denegar todo.
    if (!user) return false;

    // SuperUsuario y Admin tienen pase libre a TODO
    if (isSuperUser) return true;
    if (isAdmin) return true;

    // Usuarios normales: Verificamos el objeto permissions de forma segura
    // Usamos ?. para que no falle si el módulo o la acción no existen
    return user.permissions?.[moduleId]?.[action] === true;
  };
  
  // 3. Atajos para acciones comunes (Restaurados de tu código original)
  // Esto es vital para que no fallen tus botones de "Crear" o "Editar" en otras páginas
  const canView = (moduleId) => canDo(moduleId, 'view');
  const canCreate = (moduleId) => canDo(moduleId, 'create');
  const canEdit = (moduleId) => canDo(moduleId, 'edit');
  const canDelete = (moduleId) => canDo(moduleId, 'delete');

  return { 
      user,          // Exponemos el usuario por si se necesita
      isSuperUser, 
      isAdmin, 
      canDo,         // Función genérica
      canView,       // Helpers específicos
      canCreate, 
      canEdit, 
      canDelete 
  };
};